
import { TipStrucnogUsavrsavanja } from './tip-strucnog-usavrsavanja';
import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, NotificationService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { ControlContainer, NgForm, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
// import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'yt-tipstrucnogusavrsavanja-update',
  templateUrl: './tip-strucnog-usavrsavanja-update.component.html'
})
export class TipStrucnogUsavrsavanjaUpdateComponent extends BaseUpdateComponent<TipStrucnogUsavrsavanja> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc("Naziv", Validators.required, 'required', 'TIPSTRUCNOGUSAVRSAVANJA.NAZIV.VALIDATION.REQUIRED');
    this.addValidatorToFc("Naziv", Validators.maxLength(50), 'maxlength', 'TIPSTRUCNOGUSAVRSAVANJA.NAZIV.VALIDATION.MAXLENGTH');
  }

}
